module.exports = __webpack_public_path__ + "static/media/piano.7ba4689c.gif";